import ProvideConstants from './provide-constants'
import ProvideUtils from './provide-utils'

export function usePlugins (app) {
  app.use(ProvideConstants)
  app.use(ProvideUtils)
}